export default {
  path: '/my-card-list',
  meta: {
    title: '我的卡项',
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/my-card-list`),
}



// WEBPACK FOOTER //
// ./src/views/myCard/router.js